export const Field = ({ id, label, required, error, children, hint }) => (
  <div>
    <label htmlFor={id} className="field-label">{label}{required && <span className="text-burgundy" aria-hidden="true"> *</span>}</label>
    {children}
    {hint && <p className="mt-1 text-xs text-[#4A5568]">{hint}</p>}
    {error && <p id={`${id}-error`} className="field-error" role="alert">{error}</p>}
  </div>
);

const input = (form, set, errors, name, extra = {}) => ({
  id: name, value: form[name], className: "field-input", "aria-invalid": !!errors[name],
  "aria-describedby": errors[name] ? `${name}-error` : undefined, onChange: (e) => set({ [name]: e.target.value }),
  "data-testid": `reg-${name.replace(/_/g, "-")}-input`, ...extra,
});

const CODES = ["+1", "+44", "+1-242", "+33", "+49", "+61", "+91", "+27", "+234", "+86"];
const TITLES = ["Mr", "Mrs", "Ms", "Mx", "Dr", "Prof", "Hon", "Justice"];

export default function StepDetails({ form, set, errors, category, lockEmail = false }) {
  const req = (f) => category?.required_fields?.includes(f);
  return (
    <fieldset data-testid="step-your-details">
      <legend className="text-2xl text-navy"><span className="text-burgundy">2.</span> Your Details</legend>
      <div className="mt-5 grid gap-5 sm:grid-cols-6">
        <div className="sm:col-span-2"><Field id="title" label="Title" required error={errors.title}>
          <select {...input(form, set, errors, "title")}><option value="">Select</option>{TITLES.map((t) => <option key={t}>{t}</option>)}</select>
        </Field></div>
        <div className="sm:col-span-2"><Field id="first_name" label="First Name" required error={errors.first_name}>
          <input {...input(form, set, errors, "first_name", { autoComplete: "given-name", placeholder: "Enter your first name" })} /></Field></div>
        <div className="sm:col-span-2"><Field id="last_name" label="Last Name" required error={errors.last_name}>
          <input {...input(form, set, errors, "last_name", { autoComplete: "family-name", placeholder: "Enter your last name" })} /></Field></div>
        <div className="sm:col-span-3"><Field id="email" label="Email Address" required error={errors.email} hint={lockEmail ? "Set by your personal invitation." : undefined}>
          <input {...input(form, set, errors, "email", { type: "email", autoComplete: "email", placeholder: "you@company.com", readOnly: lockEmail, "data-testid": "reg-email-input" })} /></Field></div>
        <div className="sm:col-span-3"><Field id="phone" label="Phone Number" required error={errors.phone || errors.phone_country_code}>
          <div className="flex gap-2">
            <label htmlFor="phone_country_code" className="sr-only">Country code</label>
            <select {...input(form, set, errors, "phone_country_code", { className: "field-input w-28" })}>
              {CODES.map((c) => <option key={c} value={c.replace("-", "")}>{c}</option>)}
            </select>
            <input {...input(form, set, errors, "phone", { type: "tel", autoComplete: "tel-national", placeholder: "242 000 0000" })} />
          </div>
        </Field></div>
        <div className="sm:col-span-3"><Field id="organization" label="Organization / Firm" required={req("organization")} error={errors.organization}>
          <input {...input(form, set, errors, "organization", { autoComplete: "organization", placeholder: "Enter your organization" })} /></Field></div>
        <div className="sm:col-span-3"><Field id="job_title" label="Job Title" required={req("job_title")} error={errors.job_title}>
          <input {...input(form, set, errors, "job_title", { autoComplete: "organization-title", placeholder: "Enter your job title" })} /></Field></div>
      </div>
    </fieldset>
  );
}
export { input };
